var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import FlagIcon from '../../../FlagIcon';
export default function FormatOptionLabelWithFlag(option) {
    var _a = option, label = _a.label, value = _a.value, country = _a.country;
    var countryCode = country || value;
    if (value === '')
        return;
    return (_jsxs(OptionWrapper, { children: [_jsx(FlagIcon, { code: countryCode }, void 0), label || value] }, void 0));
}
var OptionWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n"], ["\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n"])));
var templateObject_1;
